/* eslint-disable */
import Inputmask from 'inputmask';
import {normalizePhoneForMask, syncPhoneModelOnWrite} from './_phone';

Inputmask.extendDefaults({
    showMaskOnHover: false,
});

const onlyRussianLetters = {
    mask: '[C{1}][D{254}]',
    greedy: false,
    definitions: {
        'C': {
            validator: '[а-яА-ЯёЁ]'
        },
        'D': {
            validator: '[а-яА-Я-ёЁ ]'
        }
    },
    showMaskOnFocus: false
};
const oneRussianWord = {
    mask: '[C{64}]',
    greedy: false,
    definitions: {
        'C': {
            validator: '[а-яА-Я-ёЁ]',
        },
    },
    showMaskOnFocus: false
};
const phone = {
    mask: '+P (999) 999-99-99',
    definitions: {
        'P': {
            validator: function (value) {
                return /\d/.test(value) ? {c: '7'} : false;
            }
        }
    },
    onBeforeMask: normalizePhoneForMask,
    onBeforePaste: normalizePhoneForMask,
    onBeforeWrite: syncPhoneModelOnWrite
};
const phoneAutofill = {
    mask: '+7 (999) 999-99-99',
    onBeforeWrite: syncPhoneModelOnWrite
};
const date = {
    alias: 'datetime',
    inputFormat: 'dd.mm.yyyy',
    placeholder: 'дд.мм.гггг'
};
const sum = {
    alias: 'decimal',
    digits: 2,
    groupSeparator: ' ',
    radixPoint: ',',
    placeholder: '',
    min: 0,
    max: 999999.99,
    rightAlign: false,
    showMaskOnHover: false,
    showMaskOnFocus: false,
    allowMinus: false,
    allowPlus: false,
    inputType: 'number'
};
const email = {
    mask: ['__@__'],
    definitions: {
        'E': {
            validator: '[0-9a-zA-Zа-яА-Я\ё\Ё]'
        },
        'F': {
            validator: '[0-9a-zA-Zа-яА-Я\-\ё\Ё№#\:,\.\/ ]'
        }
    },
    onBeforePaste: function (pastedValue, opts) {
        if (pastedValue.length > 10) {
            return pastedValue.substr(pastedValue.length - 10);
        }
    }
};
const sumFull = {
    alias: 'decimal',
    digits: 0,
    groupSeparator: '',
    radixPoint: ',',
    placeholder: '',
    min: 0,
    max: 9999999,
    rightAlign: false,
    showMaskOnHover: false,
    showMaskOnFocus: false,
    allowMinus: false,
    allowPlus: false,
    inputType: 'number'
};
const customEmail = {
    mask: "*{1,64}[.*{1,64}][.*{1,64}][.*{1,63}]@-{1,63}.-{1,63}[.-{1,63}][.-{1,63}]",
    greedy: !1,
    casing: "lower",
    onBeforePaste: function onBeforePaste(pastedValue, opts) {
        return pastedValue = pastedValue.toLowerCase(), pastedValue.replace("mailto:", "");
    },
    definitions: {
        "*": {
            validator: "[0-9\uff11-\uff19A-Za-z\u0410-\u044f\u0401\u0451\xc0-\xff\xb5!#$%&'*+/=?^_`{|}~-]"
        },
        "-": {
            validator: "[0-9A-Za-z-]"
        }
    },
    onUnMask: function onUnMask(maskedValue, unmaskedValue, opts) {
        return maskedValue;
    },
}

Inputmask.extendAliases({
    onlyRussianLetters,
    oneRussianWord,
    phone,
    phoneAutofill,
    date,
    sum,
    sumFull,
    customEmail
});
